export default __webpack_public_path__ + "img/eb0e1bb69dfb9b8fed0e66cdf9e2ed8c.svg";